import { isWalletAuthoritativeSnapshot, isWalletCommandResult, } from "@econ-v1/ports";
export class SqliteWalletMirrorRepository {
    #database;
    #now;
    constructor(database, options = {}) {
        this.#database = database;
        this.#now = options.now ?? (() => new Date().toISOString());
    }
    async readSnapshot() {
        const row = this.#database.selectObject("SELECT snapshot_json FROM wallet_authoritative_snapshot WHERE singleton_id = 1");
        if (row === undefined)
            return undefined;
        const value = parseJson(row.snapshot_json);
        if (!isWalletAuthoritativeSnapshot(value))
            throw new TypeError("Invalid stored wallet snapshot");
        return value;
    }
    async writeSnapshot(snapshot) {
        if (!isWalletAuthoritativeSnapshot(snapshot))
            throw new TypeError("Invalid wallet snapshot");
        this.#database.transaction("IMMEDIATE", (transaction) => {
            transaction.exec(`INSERT INTO wallet_authoritative_snapshot(singleton_id, snapshot_json, updated_at)
         VALUES (1, ?, ?)
         ON CONFLICT(singleton_id) DO UPDATE SET snapshot_json = excluded.snapshot_json, updated_at = excluded.updated_at`, { bind: [JSON.stringify(snapshot), this.#now()] });
        });
    }
    async readCommandResult(idempotencyKey) {
        if (idempotencyKey.trim() === "")
            throw new TypeError("Wallet idempotency key must not be empty");
        const row = this.#database.selectObject("SELECT result_json FROM wallet_command_results WHERE idempotency_key = ?", [idempotencyKey]);
        if (row === undefined)
            return undefined;
        const value = parseJson(row.result_json);
        if (!isWalletCommandResult(value))
            throw new TypeError("Invalid stored wallet command result");
        return value;
    }
    async writeCommandResult(idempotencyKey, result) {
        if (idempotencyKey.trim() === "" || !isWalletCommandResult(result))
            throw new TypeError("Invalid wallet command result");
        this.#database.transaction("IMMEDIATE", (transaction) => {
            transaction.exec(`INSERT INTO wallet_command_results(idempotency_key, result_json, created_at)
         VALUES (?, ?, ?)
         ON CONFLICT(idempotency_key) DO NOTHING`, { bind: [idempotencyKey, JSON.stringify(result), this.#now()] });
        });
    }
}
function parseJson(value) {
    if (typeof value !== "string")
        throw new TypeError("Stored wallet JSON is not text");
    return JSON.parse(value);
}
//# sourceMappingURL=wallet-mirror-repository.js.map